<template>
	<div class="person_box animate__animated animate__fadeIn">
		<div class="person">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">考试标题</div>
						<input type="text" class="input_box" placeholder="请输入考试标题" v-model="searchTitle" />
					</div>
					<div class="line_input">
						<div class="input_title">考试类型</div>
                        <input type="text" class="input_box" placeholder="请输入考试类型" v-model="searchType" />
						<!-- <el-select size="small" class="select_box" v-model="searchType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="安全考试" value="1">安全考试</el-option>
							<el-option label="消防考试" value="2">消防考试</el-option>
						</el-select> -->
					</div>
					<div class="line_input">
						<div class="input_title">创建时间</div>
						<el-date-picker
							size="small"
							v-model="searchCreateAt"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 392px;"
						></el-date-picker>
					</div>
					<div class="search-btn" @click="fnSearch"><span>搜索</span></div>
				</div>
				<div class="box_line">
					<div class="search-btn" @click="fnRefresh('/specialExamTest/0','7')"><span>新增考试试卷</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">考试标题</div>
					<div class="title_item">内容描述</div>
					<div class="title_item">考试类型</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item, index) in tableData" :key="index">
								<div class="list_item" :title="item.title">{{ item.title }}</div>
								<div class="list_item" :title="item.desc">{{ item.desc }}</div>
								<div class="list_item">{{ item.type }}</div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div>
										<button class="item_btn blue" @click="fnRefresh('/specialExamTest/'+item.id,'7')"><span>编辑</span></button>
										<button class="item_btn red" @click="fnDelete(item)"><span>删除</span></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import { getActiveIndex, setActiveIndex } from '@/utils/auth.js';
import store from '../../../store';
export default {
	data() {
		return {
			// 分页
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			// 搜索
			searchTitle: '', // 培训题目搜索
			searchType: '', // 培训类型搜索
			searchCreateAt: '', // 创建时间搜索
			searchTime: '',
			// 培训列表
			tableData: [], // 培训列表数据
			// 弹窗
			showAddOrEdit: false, // 新增考试弹窗
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 初始化
		fnInit() {
			this.fnGetExamList(
				{
					page: this.currentPage,
					size: this.pageSize,
				},
				res => {
					let _arr = res.data.query;
					if (_arr.length > 0) {
						this.tableData = _arr;
					}else{
						this.tableData = []
						this.$message.warning("暂无数据");
					}
					this.pageTotal = res.data.count;
				}
			);
		},
		// 分页选择 主页面
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		// 分页跳转 主页面
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
		// 获取考试列表
		fnGetExamList(_obj, _cb) {
			request({
				url: 'exam/tk/lists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索考试列表
		fnSearch(_isInit) {
			if (this.searchCreateAt) {
				this.searchTime = this.searchCreateAt[0] + ',' + this.searchCreateAt[1];
			} else {
				this.searchTime = '';
			}
			this.fnGetExamList(
				{
					page: _isInit ? 1 : this.currentPage,
					size: this.pageSize,
					title: this.searchTitle,
					type: this.searchType,
					create_at: this.searchTime,
				},
				res => {
					let _arr = res.data.query;
					if (_arr.length > 0) {
						this.tableData = _arr;
					}else{
						this.tableData = []
						this.$message.warning("暂无搜索数据");
					}
					this.pageTotal = res.data.count;
				}
			);
		},
		// 删除考试
		fnDelete(_data) {
			request({
				url: 'exam/tk/del',
				method: 'POST',
				data: {
					id: _data.id
				}
			})
				.then(res => {
					this.$message.success(res.data);
					this.fnInit();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 路由跳转
		fnRefresh(_url, _activeIndex) {
			setActiveIndex(_activeIndex);
			store.dispatch('ChangeIndex', _activeIndex);
			if (_url === this.$route.path) {
				this.$router.push({
					path: '/redirect',
					query: _url
				});
			} else {
				this.$router.push({
					path: _url
				});
			}
		},
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 84px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	&.mine_search{
		width: 860px;
		height: 74px;
		margin: 0 0 10px;
	}
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		&.mine_line{
			width: 860px;
		}
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 625px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 348px;
				margin:0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 384px;
				margin-right: 4px;
			}
			&:nth-child(3) {
				width: 344px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 344px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 348px;
				margin-right: 40px;
			}
			.select {
				width: 20px;
				height: 20px;
				border: 1px solid #65a6dd;
				border-radius: 2px;
				cursor: pointer;
				@include prefixCss3(transition, border-color 0.2s);
				&:hover {
					border-color: #409eff;
				}
				&.active {
					background-color: #409eff;
					border-color: #409eff;
					&::after {
						content: '';
						display: block;
						width: 100%;
						height: 100%;
						@include set-bg-img('../../../assets/images/icon-yes.png');
					}
				}
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 577px;
		// height: 513px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 348px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(2) {
						width: 384px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(3) {
						width: 344px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 344px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 348px;
					}
					div {
						@include flex-box(center, center);
						.item_btn {
							width: 69px;
							height: 32px;
							line-height: 32px;
							margin: 0 2px;
							font-size: 14px;
							color: #ffffff;
							border: none;
							cursor: pointer;
							@include flex-box(center, center);
							&.blue {
								background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
								background-size: 100% 100%;
							}
							&.red {
								background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
								background-size: 100% 100%;
							}
							span {
								margin-top: -2px;
							}
						}
					}
					.select {
						width: 20px;
						height: 20px;
						border: 1px solid #65a6dd;
						border-radius: 2px;
						cursor: pointer;
						@include prefixCss3(transition, border-color 0.2s);
						&:hover {
							border-color: #409eff;
						}
						&.active {
							background-color: #409eff;
							border-color: #409eff;
							&::after {
								content: '';
								display: block;
								width: 100%;
								height: 100%;
								@include set-bg-img('../../../assets/images/icon-yes.png');
							}
						}
					}
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}

.dialog_exam {
	>>> .el-dialog {
		width: 910px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	.exam_box{
		width: 860px;
		height: 450px;
		color: #FFFFFF;
		font-size: 16px;
		position: relative;
		overflow: hidden;
		.box_cont{
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.cont_form{
			>>> .el-input__inner {
				width: 450px;
				height: 30px;
				border-radius: 2px;
				border: none;
				color: rgba(77, 180, 244, 0.7);
				background-color: rgba(77, 180, 244, 0.2);
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			>>> .el-dialog__close {
				color: #4db4f4;
			}
			>>> .el-select {
				.el-input {
					.el-select__caret {
						color: rgba(77, 180, 244, 0.7);
					}
				}
			}
			>>> .el-select-dropdown {
				background-color: rgba(9, 17, 32, 0.5);
				border: 1px solid rgba(77, 180, 244, 1);
			
				background-color: rgba(9, 17, 32, 1);
				border: 1px solid rgba(77, 180, 244, 1);
			}
			>>> .el-select-dropdown__item {
				color: rgba(77, 180, 244, 0.7);
			}
			>>> .el-select-dropdown__item:hover {
				color: #409eff;
			}
			>>> .el-select-dropdown__item.hover {
				color: #409eff;
			}
			>>> .el-dropdown-menu__item--divided {
				border-top: rgba(29, 68, 149, 0.5);
				color: #9cf8fb;
			}
			>>> .el-dropdown-menu__item--divided::before {
				background-color: rgba(29, 68, 149, 0.5);
				height: 0;
			}
			>>> .popper__arrow {
				border-bottom-color: rgba(77, 180, 244, 1) !important;
			}
		}
		.mine_box{
			width: 860px;
			&.show{
				height: 465rpx;
			}
			&.hide{
				width: 100%;
				height: 0;
				overflow: hidden;
				transition: height 0.5s;
			}
			.cont_title{
				width: 860px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				color: #4db4f4;
				margin-bottom: 10px;
				background-color: rgba(49, 88, 128, 0.4);
			}
			.cont_list {
				width: 860px;
				height: 425px;
				color: #ffffff;
				font-size: 16px;
				border-radius: 10px;
				margin: 0;
				background-color: rgba(29, 68, 149, 0.1);
				.list_title {
					width: 860px;
					height: 48px;
					background: url(../../../assets/img/per_list_bg.png) no-repeat;
					background-size: 100% 100%;
					@include flex-box(flex-start, center);
					.title_item {
						height: 48px;
						@include flex-box(center, center);
						&:nth-child(1) {
							width: 61px;
							margin: 0 4px 0 30px;
						}
						&:nth-child(2) {
							width: 301px;
                            margin-right: 4px;
						}
						&:nth-child(3) {
							width: 101px;
                            margin-right: 4px;
						}
						&:nth-child(4) {
							width: 211px;
                            margin-right: 4px;
						}
						&:nth-child(5) {
							width: 110px;
							margin-right: 30px;
						}
						.select {
							width: 20px;
							height: 20px;
							border: 1px solid #65a6dd;
							border-radius: 2px;
							cursor: pointer;
							@include prefixCss3(transition, border-color 0.2s);
							&:hover {
								border-color: #409eff;
							}
							&.active {
								background-color: #409eff;
								border-color: #409eff;
								&::after {
									content: '';
									display: block;
									width: 100%;
									height: 100%;
									@include set-bg-img('../../../assets/images/icon-yes.png');
								}
							}
						}
					}
				}
				.list_boxes {
					width: 800px;
					height: 302px;
					margin-left: 30px;
					position: relative;
					overflow: hidden;
					.list_box {
						position: absolute;
						left: 0;
						right: -25px;
						top: 0;
						bottom: 0;
						overflow-x: hidden;
						overflow-y: auto;
						.box_line {
							width: 800px;
							height: 70px;
							margin: 5px 0 0 0px;
							border-bottom: 1px dashed #1d4495;
							@include flex-box(flex-start, center);
							&:hover{
								background-color: rgba(49, 88, 128, 0.4);
							}
							.list_item {
								height: 70px;
								text-align: center;
								@include flex-box(center, center);
								&:nth-child(1) {
									width: 61px;
									margin-right: 4px;
								}
								&:nth-child(2) {
									width: 301px;
									margin-right: 4px;
									cursor: pointer;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
								&:nth-child(3) {
									width: 101px;
									margin-right: 4px;
								}
								&:nth-child(4) {
									width: 211px;
									margin-right: 4px;
									cursor: pointer;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
								&:nth-child(5) {
									width: 110px;
								}
								div {
									@include flex-box(center, center);
									.item_btn {
										min-width: 69px;
										height: 32px;
										line-height: 32px;
										margin: 0 2px;
										font-size: 14px;
										color: #ffffff;
										border: none;
										cursor: pointer;
										padding: 0 5px;
										background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
										background-size: 100% 100%;
										@include flex-box(center, center);
										span {
											margin-top: -2px;
										}
									}
								}
								.select {
									width: 20px;
									height: 20px;
									border: 1px solid #65a6dd;
									border-radius: 2px;
									cursor: pointer;
									@include prefixCss3(transition, border-color 0.2s);
									&:hover {
										border-color: #409eff;
									}
									&.active {
										background-color: #409eff;
										border-color: #409eff;
										&::after {
											content: '';
											display: block;
											width: 100%;
											height: 100%;
											@include set-bg-img('../../../assets/images/icon-yes.png');
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	.btn_line {
		@include flex-box(center, center);
	}
}
</style>



// WEBPACK FOOTER //
// src/views/SpecialExam/specialExamDefault/index.vue